import { Flex, Box, Text } from '@chakra-ui/react'
import { useCoinflipStore } from './CoinflipProvider'
import { GAME_MODE } from './types'
import { memo } from 'react'
import { useTranslation } from 'next-i18next/pages'

export const RoundCounter = memo(() => {
  const { t } = useTranslation()
  const {
    view: { roundState },
    gameSteps,
    form,
  } = useCoinflipStore()
  const isInstant = form.fields.mode === GAME_MODE.INSTANT

  return (
    <Flex justifyContent={'end'} h={'full'} alignItems={'center'}>
      <Box textAlign={'center'}>
        <Text fontSize={{ base: 'md', md: '2xl' }} fontWeight={700}>
          {isInstant ? '-' : `${roundState.currentStep}/${gameSteps.length - 1}`}
        </Text>
        <Text fontSize={{ base: 'xs', md: 'sm' }} color={'ninja.200'} fontWeight={700}>
          {t('common.round')}
        </Text>
      </Box>
    </Flex>
  )
})
